import { Note } from 'domain';

export const initState = {
    list: [],
    current: null,
    isLoading: false,
    hasFailed: false
};

export default function noteReducer(state = initState, action) {
    const { type, payload } = action;

    switch (type) {
        case 'LIST_NOTE_PENDING':
        case 'GET_NOTE_PENDING':
            return { ...state, isLoading: true, hasFailed: false };

        case 'LIST_NOTE_REJECTED':
        case 'GET_NOTE_REJECTED':
            return { ...state, isLoading: false, hasFailed: true };

        case 'LIST_NOTE_FULFILLED':
            return {
                ...state,
                list: payload.map(item => new Note(item)),
                isLoading: false,
                hasFailed: false
            };

        case 'GET_NOTE_FULFILLED':
            return {
                ...state,
                current: new Note(payload),
                isLoading: false,
                hasFailed: false
            };

        default:
            return state;
    }
}